
define('text!views/shared/phone/phone_carousel.html',[],function () { return '\r\n<div id="series-wrap" class="series-wrap noNegMargin"></div>\r\n\r\n<div id="partner-root-bullet-nav-wrap" class="partner-root-bullet-nav-wrap"></div>';});

